import { AbstractControl, ValidationErrors } from '@angular/forms';

// TCKN doğrulama fonksiyonu
export function validateTCKN(control: AbstractControl): ValidationErrors | null {
  const tckn = control.value;

  if (!tckn) return null; // Boş bırakılmışsa doğrulama hatası verme
  if (!/^\d{11}$/.test(tckn)) return { invalidTCKN: true }; // 11 haneli sayı değilse geçersiz
  if (tckn[0] === '0') return { invalidTCKN: true }; // İlk hane 0 olamaz

  // Algoritmik doğrulama
  let totalOdd = 0;
  let totalEven = 0;
  for (let i = 0; i < 9; i++) {
    if (i % 2 === 0) {
      totalOdd += parseInt(tckn[i], 10);
    } else {
      totalEven += parseInt(tckn[i], 10);
    }
  }

  const tenthDigit = ((totalOdd * 7) - totalEven) % 10;
  if (tenthDigit !== parseInt(tckn[9], 10)) return { invalidTCKN: true };

  const total = totalOdd + totalEven + parseInt(tckn[9], 10);
  const eleventhDigit = total % 10;
  if (eleventhDigit !== parseInt(tckn[10], 10)) return { invalidTCKN: true };

  return null; // Geçerli TCKN
}



export function validateTRPhone10(control: AbstractControl): ValidationErrors | null {
  const v: string = (control.value ?? '').toString();
  if (!v) return null;                  // required ayrı
  return /^\d{10}$/.test(v) ? null : { invalidPhone: true };
}


export function validateTaxNo10(control: AbstractControl): ValidationErrors | null {
  const v: string = (control.value ?? '').toString();
  if (!v) return null;
  const ok = /^\d{10}$/.test(v); // sadece rakam ve 10 hane
  return ok ? null : { invalidTaxNo: true };
}
